






























import '@/scss/blocks/error-message.scss';

import validationMixin from '@/utils/mixins/validation';
import inputarea from '@/vue/components/inputarea.vue';
import Vue, { PropOptions } from 'vue';
import { VueConstructor } from 'vue/types/umd';
import patternMixin from '@/utils/mixins/pattern';
import maskMixin from '@/utils/mixins/mask';
import { secureListeners } from '@/utils/props';

export default (Vue as VueConstructor<Vue
    & InstanceType<typeof validationMixin>
    & InstanceType<typeof maskMixin>
    & InstanceType<typeof patternMixin>
>).extend({
    components: {
        inputarea,
    },
    mixins: [validationMixin, maskMixin, patternMixin],
    props: {
        /* eslint-disable key-spacing */
        dataQa               : {} as PropOptions<string>,
        invalid              : {} as PropOptions<boolean | null>,
        maxlength            : {} as PropOptions<number | null>,
        minlength            : {} as PropOptions<number | null>,
        placeholder          : {} as PropOptions<string | null>,
        patternInvalidPrompt : {} as PropOptions<string | null>,
        validationPattern    : {} as PropOptions<string | null>,
        validatePatternOnEdit: {} as PropOptions<string | null>,
        value                : {} as PropOptions<string | null>,
    },
    data () {
        return {
            input: this.mask_input(this.value),
            caretPosition: 0,
            prevCaretPosition: 0,
        };
    },
    computed: {
        highlightInvalid (): boolean {
            return this.invalid || (!!this.validation_error && this.validation_highlight);
        },
    },
    watch: {
        value (value) {
            this.setInput(value);

            if (this.validatePatternOnEdit) {
                this.private_displayError(false);
                this.validation_changed();
            }
        },
    },
    methods: {
        secureListeners,
        validation_isEmpty () {
            return !(this.input && this.input.trim());
        },
        validation_focusError () {
            this.$emit('focus');
        },
        validation_invalid () {
            if (this.minlength && (this.input || '').length < this.minlength) {
                return this.$trl('aw.minlength_invalid', String(this.minlength));
            }
            let inputWoMask = this.mask_clear(this.input);
            if (inputWoMask &&
                typeof (this.validationPattern) === 'string' &&
                (inputWoMask.match(this.validationPattern) === null ||
                    (inputWoMask.match(this.validationPattern) as RegExpMatchArray)[0] !== inputWoMask)) {
                return this.patternInvalidPrompt || this.$trl('aw.pattern_invalid');
            }
        },
        handleEnter () {
            this.$emit('keydown.enter');
            this.$emit('finished');
        },
        onFocus (event) {
            this.$emit('focus', event);
            this.$nextTick(() => { // awaits this.input to be changed
                if (event.srcElement && event.srcElement.setSelectionRange && event.srcElement.type !== 'number') {
                    event.srcElement.setSelectionRange(0, this.mask_trim(this.input)?.length || 9999);
                }
            });
        },
        onBlur () {
            this.caretPosition = -1;
            this.$emit('blur');
        },
        onBackspace (event) {
            if (!this.mask || this.input === null) {
                return;
            }

            event.preventDefault();
            let fieldEl = event.srcElement;
            this.updateCarret(event);
            if (fieldEl.selectionEnd === fieldEl.selectionStart) {
                if (event.key === 'Delete') {
                    this.caretPosition = this.findNextCaretPosition({ caretPosition: this.caretPosition + 1, forward: true }) - 1;
                    this.setInput(this.input.slice(0, this.caretPosition) + this.input.slice(this.caretPosition + 1));
                } else {
                    this.caretPosition = this.findNextCaretPosition({ caretPosition: this.caretPosition - 1, forward: false });
                    this.setInput(this.input.slice(0, this.caretPosition) + this.input.slice(this.caretPosition + 1));
                }
            } else {
                this.setInput(this.input.slice(0, fieldEl.selectionStart) + this.input.slice(fieldEl.selectionEnd));
                this.caretPosition = fieldEl.selectionStart;
            }
            this.$nextTick(() => { // awaits this.input to be changed
                this.moveCarret(fieldEl, this.caretPosition);
            });
        },
        onInput (value, event) {
            if (this.mask) {
                this.updateCarret(event);
                this.setInput(value);
                this.$nextTick(() => { // awaits this.input to be changed
                    this.moveCarret(event.srcElement, this.mask_trim(this.input)?.length || 0);
                });
            } else {
                this.setInput(value);
            }
        },
        onClick (event) {
            // if (this.caretPosition === -1) {
            //     this.moveCarret(event.srcElement, 0, -1);
            // }

            this.$emit('click');
        },
        updateCarret (event) {
            if (event && event.srcElement && event.srcElement.selectionStart) { // missed on test's env
                this.caretPosition = event.srcElement.selectionStart;
            }
        },
        findNextCaretPosition ({ caretPosition, forward }: { caretPosition: number; forward: boolean }) {
            if (this.mask === null) {
                return;
            }

            if (caretPosition > this.mask.length) {
                return this.mask.length + 1;
            }

            if (caretPosition < 0) {
                return 0;
            }

            if (this.mask[caretPosition + (forward ? -1 : 0)] !== '#') {
                return this.findNextCaretPosition({ caretPosition: caretPosition + (forward ? 1 : -1), forward });
            }

            return caretPosition;
        },
        setInput (value: string) {
            this.input = this.mask_input(this.pattern_input(this.mask_clear(value))) || '';
            let eValue = this.pattern_input(this.mask_clear(this.input)) || '';
            this.$emit('input', eValue);
            this.$emit('value', eValue);

            this.$forceUpdate();
            this.validation_changed();
        },
        moveCarret (element: HTMLInputElement, start: number, end?: number) {
            if (element) { // missed on test's env
                element.selectionStart = start;
                element.selectionEnd = end || start;
            }
        },
    },
});
